/* joacă bună — galeria, cantitatea și variantele paginii de produs.
   Fără JS, selectul nativ din <noscript> trimite varianta aleasă. Cu JS, câmpul
   ascuns primește name=id numai după inițializarea completă. */
(function () {
  'use strict';

  var radacina = document.querySelector('.produs-pag');
  if (!radacina) return;

  var formular = radacina.querySelector('.cumpara__form');
  var campId = radacina.querySelector('[data-id-varianta]');
  var buton = radacina.querySelector('[data-adauga]');
  var butonText = radacina.querySelector('[data-adauga-text]');
  var mesaj = radacina.querySelector('[data-varianta-mesaj]');
  var disponibilitate = radacina.querySelector('[data-disponibilitate]');
  var pretCurent = radacina.querySelector('[data-pret-curent]');
  var pretVechi = radacina.querySelector('[data-pret-vechi]');
  var baraSticky = radacina.querySelector('[data-cumpara-sticky]');
  var butonSticky = radacina.querySelector('[data-adauga-sticky]');
  var butonStickyText = radacina.querySelector('[data-adauga-sticky-text]');
  var pretSticky = radacina.querySelector('[data-pret-sticky]');
  var culoareAleasa = radacina.querySelector('[data-culoare-aleasa]');
  var sku = radacina.querySelector('[data-sku]');
  var skuRand = radacina.querySelector('[data-sku-rand]');
  var mareContainer = radacina.querySelector('[data-galerie-mare]');
  var mare = radacina.querySelector('[data-galerie-mare] img');
  var sursa = radacina.querySelector('[data-variante]');
  var copy = {
    adauga: radacina.getAttribute('data-copy-adauga') || '',
    epuizat: radacina.getAttribute('data-copy-epuizat') || '',
    disponibil: radacina.getAttribute('data-copy-disponibil') || '',
    combinatie: radacina.getAttribute('data-copy-combinatie') || '',
    init: radacina.getAttribute('data-copy-init') || ''
  };
  var variante = [];

  function arataMesaj(text) {
    if (!mesaj) return;
    mesaj.textContent = text;
    mesaj.hidden = !text;
  }

  function actualizeazaCuloare() {
    if (!culoareAleasa) return;
    var aleasa = radacina.querySelector('[data-optiune-culoare] input:checked');
    if (!aleasa) return;
    var sablon = culoareAleasa.getAttribute('data-template') || '__NUME__';
    culoareAleasa.textContent = sablon.replace('__NUME__', aleasa.value);
  }

  function sincronizeazaBara() {
    if (!butonSticky) return;
    butonSticky.disabled = !buton || buton.disabled;
    if (butonStickyText && butonText) butonStickyText.textContent = butonText.textContent;
    if (pretSticky && pretCurent) pretSticky.textContent = pretCurent.textContent;
  }

  function blocheaza(text) {
    if (campId) campId.disabled = true;
    if (buton) buton.disabled = true;
    if (butonText) butonText.textContent = copy.epuizat;
    if (disponibilitate) disponibilitate.textContent = text;
    arataMesaj(text);
    sincronizeazaBara();
  }

  if (!formular || !campId || !buton || !sursa) {
    blocheaza(copy.init);
    return;
  }

  try {
    variante = JSON.parse(sursa.textContent);
  } catch (e) {
    blocheaza(copy.init);
    return;
  }
  if (!Array.isArray(variante) || !variante.length) {
    blocheaza(copy.init);
    return;
  }

  /* ---------- galerie ---------- */
  function activeazaMiniatura(id) {
    radacina.querySelectorAll('[data-galerie-mic]').forEach(function (miniatura) {
      var activa = id != null && miniatura.getAttribute('data-media-id') === String(id);
      miniatura.classList.toggle('este-activ', activa);
      miniatura.setAttribute('aria-pressed', activa ? 'true' : 'false');
    });
  }

  function aplicaImagine(media) {
    if (!mare || !media || !media.src) return;
    mare.src = media.src;
    if (media.srcset) mare.setAttribute('srcset', media.srcset);
    else mare.removeAttribute('srcset');
    if (media.sizes) mare.setAttribute('sizes', media.sizes);
    else mare.removeAttribute('sizes');
    mare.alt = media.alt || '';
    activeazaMiniatura(media.id);
    if (mareContainer) mareContainer.classList.remove('is-zoomed');
  }

  radacina.addEventListener('click', function (e) {
    var miniatura = e.target.closest('[data-galerie-mic]');
    if (!miniatura || !mare) return;
    aplicaImagine({
      id: miniatura.getAttribute('data-media-id'),
      src: miniatura.getAttribute('data-mare'),
      srcset: miniatura.getAttribute('data-srcset'),
      sizes: miniatura.getAttribute('data-sizes'),
      alt: miniatura.getAttribute('data-alt')
    });
  });

  /* ---------- zoom galerie — mouse și deget, fără tastatură (decizie Bogdan, 8 aug 2026).
     Desktop: originea transformului urmărește cursorul, scala vine din CSS la :hover.
     Mobil: tap comută .is-zoomed, pan pe touchmove cât e zoomat (nu se interpretează
     și ca tap la ridicarea degetului). Ramurile sunt exclusive prin matchMedia, deci la
     prefers-reduced-motion:reduce niciun listener nu se atașează. ---------- */
  if (mareContainer && mare) {
    var setOrigine = function (x, y) {
      var r = mareContainer.getBoundingClientRect();
      var clamp = function (val) { return Math.min(100, Math.max(0, val)); };
      mareContainer.style.setProperty('--zx', clamp(((x - r.left) / r.width) * 100).toFixed(2) + '%');
      mareContainer.style.setProperty('--zy', clamp(((y - r.top) / r.height) * 100).toFixed(2) + '%');
    };
    if (window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
      mareContainer.addEventListener('pointermove', function (e) { setOrigine(e.clientX, e.clientY); });
    } else if (window.matchMedia('(hover: none) and (prefers-reduced-motion: no-preference)').matches) {
      var degetMiscat = false;
      mareContainer.addEventListener('touchstart', function () { degetMiscat = false; }, { passive: true });
      mareContainer.addEventListener('click', function (e) {
        if (degetMiscat) { degetMiscat = false; return; }
        mareContainer.classList.toggle('is-zoomed');
        if (mareContainer.classList.contains('is-zoomed')) setOrigine(e.clientX, e.clientY);
      });
      mareContainer.addEventListener('touchmove', function (e) {
        if (!mareContainer.classList.contains('is-zoomed')) return;
        degetMiscat = true;
        e.preventDefault();
        var t = e.touches[0];
        setOrigine(t.clientX, t.clientY);
      }, { passive: false });
    }
  }

  /* ---------- cantitate ---------- */
  var campCantitate = radacina.querySelector('[data-cant]');
  radacina.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-cant-plus]');
    var minus = e.target.closest('[data-cant-minus]');
    if ((!plus && !minus) || !campCantitate) return;
    var min = parseInt(campCantitate.min, 10) || 1;
    var valoare = parseInt(campCantitate.value, 10) || min;
    campCantitate.value = plus ? valoare + 1 : Math.max(min, valoare - 1);
    campCantitate.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variante ---------- */
  function optiuniAlese() {
    var controale = radacina.querySelectorAll('[data-optiune]');
    if (!controale.length) return null;
    var valori = [];
    radacina.querySelectorAll('[data-optiune]:checked').forEach(function (input) {
      valori[parseInt(input.getAttribute('data-optiune'), 10) - 1] = input.value;
    });
    return valori;
  }

  function gasesteVarianta(valori) {
    if (valori === null) {
      return variante.find(function (varianta) { return String(varianta.id) === String(campId.value); }) || null;
    }
    return variante.find(function (varianta) {
      if (!Array.isArray(varianta.options) || varianta.options.length !== valori.length) return false;
      for (var i = 0; i < varianta.options.length; i++) {
        if (valori[i] === undefined || varianta.options[i] !== valori[i]) return false;
      }
      return true;
    }) || null;
  }

  function marcheazaOptiuni(valori) {
    if (valori === null) return;
    radacina.querySelectorAll('[data-optiune]').forEach(function (input) {
      var pozitie = parseInt(input.getAttribute('data-optiune'), 10) - 1;
      var posibila = variante.some(function (varianta) {
        if (!varianta.available || varianta.options[pozitie] !== input.value) return false;
        for (var i = 0; i < valori.length; i++) {
          if (i !== pozitie && valori[i] !== undefined && varianta.options[i] !== valori[i]) return false;
        }
        return true;
      });
      var eticheta = input.nextElementSibling;
      if (eticheta) eticheta.classList.toggle('este-indisponibila', !posibila);
      input.setAttribute('aria-disabled', posibila ? 'false' : 'true');
    });
  }

  function actualizeaza() {
    var valori = optiuniAlese();
    var varianta = gasesteVarianta(valori);
    marcheazaOptiuni(valori);
    actualizeazaCuloare();

    if (!varianta) {
      blocheaza(copy.combinatie);
      return false;
    }

    campId.value = varianta.id;
    campId.disabled = false;
    arataMesaj('');

    if (pretCurent) pretCurent.textContent = varianta.price;
    if (pretVechi) {
      pretVechi.hidden = !varianta.compareAtPrice;
      if (varianta.compareAtPrice) pretVechi.textContent = varianta.compareAtPrice;
    }

    if (sku && skuRand) {
      sku.textContent = varianta.sku || '';
      skuRand.hidden = !varianta.sku;
    }

    buton.disabled = !varianta.available;
    if (butonText) butonText.textContent = varianta.available ? copy.adauga : copy.epuizat;
    if (disponibilitate) disponibilitate.textContent = varianta.available ? copy.disponibil : copy.epuizat;
    sincronizeazaBara();

    if (varianta.media) aplicaImagine(varianta.media);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', varianta.id);
      window.history.replaceState({}, '', url.toString());
    }
    return true;
  }

  if (baraSticky && butonSticky && 'IntersectionObserver' in window) {
    var aFostVizibil = false;

    function arataBara(arata) {
      baraSticky.classList.toggle('este-vizibila', arata);
      baraSticky.setAttribute('aria-hidden', arata ? 'false' : 'true');
      radacina.classList.toggle('are-sticky', arata);
      if (arata) {
        radacina.style.setProperty('--sticky-h', baraSticky.offsetHeight + 'px');
      }
    }

    baraSticky.hidden = false;
    sincronizeazaBara();

    butonSticky.addEventListener('click', function () {
      if (butonSticky.disabled) return;
      if (typeof formular.requestSubmit === 'function') formular.requestSubmit(buton);
      else buton.click();
    });

    new IntersectionObserver(function (intrari) {
      var intrare = intrari[0];
      if (intrare.isIntersecting) {
        aFostVizibil = true;
        arataBara(false);
        return;
      }
      arataBara(aFostVizibil && intrare.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buton);

    window.addEventListener('resize', function () {
      if (baraSticky.classList.contains('este-vizibila')) {
        radacina.style.setProperty('--sticky-h', baraSticky.offsetHeight + 'px');
      }
    });
  }

  formular.addEventListener('submit', function (e) {
    if (campId.disabled || !campId.value || buton.disabled) {
      e.preventDefault();
      blocheaza(campId.disabled || !campId.value ? copy.init : copy.epuizat);
    }
  });

  radacina.addEventListener('change', function (e) {
    if (e.target.hasAttribute && e.target.hasAttribute('data-optiune')) actualizeaza();
  });

  if (!actualizeaza()) blocheaza(copy.init);
})();
